import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'swatch'];

  connect() {
    this.update();
  }

  update() {
    const raw = (this.inputTarget.value || '').trim();
    const normalized = this.normalizeHex(raw);

    if (normalized) {
      this.swatchTarget.style.backgroundColor = normalized;
      this.inputTarget.classList.remove('is-invalid');
    } else {
      if (raw === '') {
        this.inputTarget.classList.remove('is-invalid');
        return;
      }

      this.inputTarget.classList.add('is-invalid');
    }
  }

  normalizeHex(value) {
    let v = value;
    if (v.startsWith('#')) v = v.slice(1);

    if (/^[0-9a-fA-F]{3}$/.test(v)) {
      v = v
        .split('')
        .map((c) => c + c)
        .join('');
    }

    if (/^[0-9a-fA-F]{6}$/.test(v)) {
      return `#${v.toUpperCase()}`;
    }

    return null;
  }
}
